// ===============================================
// 🎮 STEAM SERVICE (ЧЕРЕЗ БЭКЕНД API)
// ===============================================

import backendApiService from './backend-api.service';

const steamService = {
  async getCurrencyRates() {
    try {
      const result = await backendApiService.getCurrencyRates();

      if (result.success && result.rates) {
        if (typeof window !== 'undefined' && window.localStorage) {
          const ratesData = {
            rates: result.rates,
            timestamp: Date.now(),
            source: result.source,
          };
          localStorage.setItem('steam_currency_rates', JSON.stringify(ratesData));
        }

        return result.rates;
      }
      throw new Error('Неверный ответ от бэкенда');
    } catch (error) {
      const cachedRates = this.getCachedRates();
      if (cachedRates) {
        return cachedRates;
      }

      throw error;
    }
  },

  getCachedRates() {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }

    try {
      const cached = localStorage.getItem('steam_currency_rates');
      if (!cached) return null;

      const data = JSON.parse(cached);
      const now = Date.now();
      const maxAge = 2 * 60 * 60 * 1000;

      if (now - data.timestamp < maxAge) {
        return data.rates;
      }
      localStorage.removeItem('steam_currency_rates');
      return null;
    } catch {
      return null;
    }
  },

  async getCurrencyRatesWithCache(forceRefresh = false) {
    try {
      if (forceRefresh) {
        return await this.getCurrencyRates();
      }

      const cachedRates = this.getCachedRates();
      if (cachedRates) {
        return cachedRates;
      }

      return await this.getCurrencyRates();
    } catch {
      return null;
    }
  },

  async verifySteamAccount(account, captchaToken) {
    return backendApiService.verifySteamAccount(account, captchaToken);
  },

  async createSteamPayment(account, amount, currency = 'USD') {
    return backendApiService.createSteamPayment(account, amount, currency);
  },

  async topupSteamAccount(account, amount, paymentId) {
    return backendApiService.topupSteamAccount(account, amount, paymentId);
  },

  async createSBPQR(amount, orderId, description = 'Пополнение Steam') {
    return backendApiService.createSBPQR(amount, orderId, description);
  },

  async checkSBPPaymentStatus(paymentGuid) {
    return backendApiService.checkSBPPaymentStatus(paymentGuid);
  },

  async healthCheck() {
    return backendApiService.healthCheck();
  },

  generateOrderId() {
    return `order_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  },

  generatePaymentId() {
    return `payment_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  },

  formatCurrency(amount, currency = 'USD') {
    const formatter = new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
    });
    return formatter.format(amount);
  },

  async isBackendAvailable() {
    try {
      await this.healthCheck();
      return true;
    } catch {
      return false;
    }
  },
};

export default steamService;
